import { TModelItem } from "../../../../../services/api/instances/modelsApi/types";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { useSelectModel } from "./hooks/use-select-model";

interface Props {
  modelId: string | null;
  updateObject: (model: TModelItem | null) => void;
  emptyOptionLabel?: string;
  isDisabled?: boolean;
}

export const ModelsSelect = (props: Props) => {
  const { models, selectedModel, handleSelectModel } = useSelectModel(
    props.modelId,
    props.updateObject,
  );

  return (
    <GenericSelect<TModelItem>
      options={models}
      value={selectedModel}
      onChange={handleSelectModel}
      getLabel={(model) => model.id}
      getValue={(model) => model.id}
      emptyOptionLabel={
        props.emptyOptionLabel ? props.emptyOptionLabel : undefined
      }
      isDisabled={props.isDisabled}
      placeholder={"Выберите модель"}
    />
  );
};
